import { gql } from '@apollo/client'

const UPDATE_AWARD_SIMPLE_DETAILS_MUTATION = gql`
  mutation updateAwardSimpleDetails($id: ID!, $data: AwardDetailsInput!) {
    updateAwardSimpleDetails(id: $id, data: $data) {
      id
      description
      position
      updatedAt
      updatedBy {
        id
        name
      }
    }
  }
`

export default UPDATE_AWARD_SIMPLE_DETAILS_MUTATION
